import React from "react";
import styles from "../../_css/DataAccessAndReport.module.css";

const UserTable = ({
  filtereddata,
  startIndex,
  selectedIds = [],
  onSelectionChange = () => {},
}) => {

  const getRowId = (row) => {
    return row?.id ?? row?._id ?? row?.user_id ?? row?.userId ?? null;
  };

  const pageIds = filtereddata
    .map((row) => getRowId(row))
    .filter((id) => id !== null && id !== undefined);

  const allSelectedOnPage =
    pageIds.length > 0 && pageIds.every((id) => selectedIds.includes(id));

  const handleHeaderCheckboxChange = (e) => {
    const checked = e.target.checked;
    if (checked) {
      const newIds = Array.from(new Set([...selectedIds, ...pageIds]));
      onSelectionChange(newIds);
    } else {
      const pageIdSet = new Set(pageIds);
      const newIds = selectedIds.filter((id) => !pageIdSet.has(id));
      onSelectionChange(newIds);
    }
  };

  const handleRowCheckboxChange = (rowId, checked) => {
    if (rowId === null || rowId === undefined) return;
    if (checked) {
      if (!selectedIds.includes(rowId)) {
        onSelectionChange([...selectedIds, rowId]);
      }
    } else {
      onSelectionChange(selectedIds.filter((id) => id !== rowId));
    }
  };

  return (
    <div className={`${styles.userTableContainer} custom-scrollbar`}>
      <div className={styles.userTableWrapper}>
        <table className={styles.userTable}>
          <thead className={styles.userThead}>
            <tr>
              <th className={styles.userThSl}>
                <div className="d-flex align-items-center">
                  <input
                    type="checkbox"
                    className="form-check-input me-2"
                    checked={allSelectedOnPage}
                    onChange={handleHeaderCheckboxChange}
                  />
                  <span>S.L</span>
                </div>
              </th>
              <th className={styles.userThName}>Name</th>
              <th className={styles.userThEmail}>Email</th>
              <th className={styles.userThCompany}>Company</th>
              <th className={styles.userThDepartment}>Department</th>
              <th className={styles.userThCompetencies}>Top Competencies</th>
            </tr>
          </thead>
          <tbody>
            {filtereddata.map((row, index) => {
              const isLastRow = index === filtereddata.length - 1;
              const rowId = getRowId(row);
              const isChecked =
                rowId !== null && rowId !== undefined
                  ? selectedIds.includes(rowId)
                  : false;
              return (
                <tr key={rowId ?? index} className={styles.userRow}>
                  <td
                    className={`${styles.userTdSl} ${
                      isLastRow ? styles.userTdSlLast : ""
                    }`}
                  >
                    <div className="d-flex align-items-center">
                      <input
                        type="checkbox"
                        className="form-check-input me-3"
                        checked={isChecked}
                        onChange={(e) =>
                          handleRowCheckboxChange(rowId, e.target.checked)
                        }
                      />
                      <span className={styles.userSlText}>
                        {String(startIndex + index + 1).padStart(2, "0")}
                      </span>
                    </div>
                  </td>
                  <td className={`${styles.userTd} ${styles.userNameCell}`}>
                    <span className="d-flex align-items-center">
                      <span
                        className={`me-3 d-flex align-items-center justify-content-center ${styles.userNameAvatar}`}
                      >
                        {row?.image ? (
                          <img
                            src={row?.image}
                            alt={row?.name}
                            className={styles.userAvatarImage}
                          />
                        ) : (
                          <span>👤</span>
                        )}
                      </span>
                      <span className={styles.userNameText}>
                        {row?.name || "N/A"}
                      </span>
                    </span>
                  </td>
                  <td
                    className={`${styles.userTd} ${styles.userEmailCell}`}
                  >
                    {row.email}
                  </td>
                  <td
                    className={`${styles.userTd} ${styles.userCompanyCell}`}
                  >
                    {row.company || "Not Available"}
                  </td>
                  <td
                    className={`${styles.userTd} ${styles.userDepartmentCell}`}
                  >
                    {row.department || "Not Available"}
                  </td>
                  <td
                    className={`${styles.userCompetenciesCell} ${
                      isLastRow ? styles.userCompetenciesCellLast : ""
                    }`}
                  >
                    <div className={styles.userCompetenciesList}>
                      {row?.topCompetencies?.map(
                        (competency, competencyIndex) => (
                          <span
                            key={competencyIndex}
                            className={styles.userCompetencyTag}
                          >
                            {competency}
                          </span>
                        )
                      )}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UserTable;